import { useTheme } from "@emotion/react";
import { useRef } from "react";
import { getFileDataURL } from "utils";

function ImageUpload({ themeVar, setFile, themeColors, setThemeColors, altText = "image" }) {
    const theme = useTheme();
    const fileInputRef = useRef(null);

    /** @param {React.ChangeEvent<HTMLInputElement>} event */
    const handleFileChange = async (event) => {
        const file = event.target.files[0];

        if (file) {
            // Data URL is used to show the image preview, the file object is what gets sent to the server. It's done
            // this way because the data URL is base64 encoded which increases the file size by approximately 33%.
            const dataURL = await getFileDataURL(file);
            setThemeColors((theme) => ({ ...theme, [themeVar]: dataURL }));
            setFile(file);
        }
    };

    const handleButtonClick = () => {
        fileInputRef.current.click();
    };

    return (
        <div className="flex items-center space-x-[18px]">
            <div className="overflow-hidden border border-slate-200 rounded-[6px] w-[104px] h-[59px] flex items-center justify-center">
                <div className="w-full h-full relative" style={{ backgroundColor: theme.palette.grey.light }}>
                    <img
                        src={themeColors[themeVar]}
                        alt={altText}
                        className="w-auto h-auto absolute top-[50%] left-0 translate-y-[-50%]"
                    />
                </div>
            </div>
            <input ref={fileInputRef} onChange={handleFileChange} type="file" accept="image/*" hidden />
            <div className="text-[#0A6F7F] cursor-pointer" onClick={handleButtonClick}>
                Edit
            </div>
        </div>
    );
}

export default ImageUpload;
